module.exports = __webpack_public_path__ + "static/media/Lato-Black.d83ab24f.ttf";